<template>
  <div class="invoice-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb">
      <span class="breadcrumb-item" @click="goToProfile">个人中心</span>
      <span class="breadcrumb-separator"> > </span>
      <span class="breadcrumb-item" @click="goToInvoiceManage">发票管理</span>
      <span class="breadcrumb-separator"> > </span>
      <span class="breadcrumb-item active">开票</span>
    </div>

    <div class="con-box">
      <!-- 发票类型选择 -->
      <div class="invoice-type-section">
        <div class="type-header">
          <div class="section-label">发票类型</div>
        </div>
        <div class="type-buttons">
          <el-button
            class="type-btn"
            :class="{ active: invoiceType === 'general' }"
            @click="invoiceType = 'general'"
          >
            普票
          </el-button>
          <el-button
            class="type-btn"
            :class="{ active: invoiceType === 'special' }"
            @click="invoiceType = 'special'"
          >
            专票
          </el-button>
        </div>
      </div>

      <!-- 开票表单 -->
      <div class="invoice-form">

        <div class="form-content">
          <div class="form-row">
            <div class="form-item">
              <label class="form-label required">模板名称(必填)</label>
              <el-input
                v-model="formData.templateName"
                placeholder="请输入模板名称"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-item">
              <label class="form-label required">单位名称(必填)</label>
              <el-input
                v-model="formData.companyName"
                placeholder="请输入你的单位名称"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-item">
              <label class="form-label required">纳税人识别号(必填)</label>
              <el-input
                v-model="formData.taxNumber"
                placeholder="请输入纳税人识别号"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-item">
              <label class="form-label">地址</label>
              <el-input
                v-model="formData.address"
                placeholder="请输入地址"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-item">
              <label class="form-label">电话</label>
              <el-input
                v-model="formData.phone"
                placeholder="请输入联系电话"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-item">
              <label class="form-label">开户行(选填)</label>
              <el-input
                v-model="formData.bankName"
                placeholder="请输入开户行"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-item">
              <label class="form-label">开户行账号(选填)</label>
              <el-input
                v-model="formData.bankAccount"
                placeholder="请输入开户行账号"
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-item">
              <label class="form-label">是否设为默认模板</label>
              <el-switch
                v-model="formData.isDefault"
                active-text="是"
                inactive-text="否"
                class="form-switch"
              />
            </div>
          </div>
        </div>

        <div class="form-actions">
          <el-button
            type="primary"
            class="confirm-btn"
            @click="saveTemplate"
          >
            确定
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProfile } from '@/api/user'

export default {
  name: 'Invoice',
  data() {
    return {
      invoiceType: 'special', // 默认选择专票
      formData: {
        templateName: '',
        companyName: '',
        taxNumber: '',
        address: '',
        phone: '',
        bankName: '',
        bankAccount: '',
        isDefault: false
      }
    }
  },
  async created() {
    try {
      const res = await getProfile()
      const gid = res && res.data != null ? Number(res.data.group_id) : NaN
      if (!res || res.code !== 1 || gid !== 1) {
        this.$router.replace('/profile/index')
      }
    } catch (e) {
      this.$router.replace('/profile/index')
    }
  },
  methods: {
    goToProfile() {
      this.$router.push('/profile')
    },
    goToInvoiceManage() {
      this.$router.push({ path: '/profile/index', query: { activeMenu: '4' }})
    },
    async saveTemplate() {
      // 验证必填字段
      if (!this.formData.templateName) {
        this.$message.warning('请填写模板名称')
        return
      }
      if (!this.formData.companyName) {
        this.$message.warning('请填写单位名称')
        return
      }
      if (!this.formData.taxNumber) {
        this.$message.warning('请填写纳税人识别号')
        return
      }

      try {
        const { saveInvoiceTemplate } = await import('@/api/user')
        const params = {
          template_name: this.formData.templateName,
          invoice_type: this.invoiceType === 'general' ? 1 : 2,
          company_name: this.formData.companyName,
          taxpayer_id: this.formData.taxNumber,
          address: this.formData.address,
          phone: this.formData.phone,
          bank_name: this.formData.bankName,
          bank_account: this.formData.bankAccount,
          is_default: this.formData.isDefault ? 1 : 0
        }

        await saveInvoiceTemplate(params)
        this.$message.success('模板保存成功')

        // 清空表单
        this.formData = {
          templateName: '',
          companyName: '',
          taxNumber: '',
          address: '',
          phone: '',
          bankName: '',
          bankAccount: '',
          isDefault: false
        }
      } catch (error) {
        console.error('保存模板失败:', error)
        this.$message.error('保存模板失败，请重试')
      }
    },
    submitInvoice() {
      if (!this.formData.companyName) {
        this.$message.warning('请填写单位名称')
        return
      }
      if (!this.formData.taxNumber) {
        this.$message.warning('请填写纳税人识别号')
        return
      }
      this.$message.success('发票申请已提交')
      // 这里可以添加提交发票申请的逻辑
    }
  }
}
</script>

<style scoped>
.invoice-container {
  min-height: 100vh;
  background: #F5F5F5;
  padding: 20px;
}

.breadcrumb {
  max-width: 1200px;
  margin: 0 auto 20px;
  padding: 20px;
  background: #fff;
  border-radius: 12px;
}

.breadcrumb-item {
  color: #606266;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
}

.breadcrumb-item:hover {
  color: #1E80FF;
}

.breadcrumb-item.active {
  color: #303133;
  cursor: default;
}

.breadcrumb-separator {
  color: #C0C4CC;
  margin: 0 8px;
}

.con-box {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 发票类型选择 */
.invoice-type-section {
  margin-bottom: 32px;
}

.type-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.section-label {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.type-buttons {
  display: flex;
  gap: 16px;
}

.type-btn {
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  border: 1px solid #E4E7ED;
  background: #fff;
  color: #606266;
  transition: all 0.3s;
}

.type-btn:hover {
  border-color: #1E80FF;
  color: #1E80FF;
}

.type-btn.active {
  background: #1E80FF;
  border-color: #1E80FF;
  color: #fff;
}

/* 开票表单 */
.invoice-form {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  border: 1px solid #E4E7ED;
}

.save-template-btn {
  color: #1E80FF;
  font-size: 14px;
  padding: 0;
}

.form-content {
  margin-bottom: 32px;
}

.form-row {
  margin-bottom: 20px;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-item {
  width: 100%;
}

.form-label {
  display: block;
  font-size: 14px;
  color: #303133;
  margin-bottom: 8px;
  font-weight: 500;
}

.form-label.required::after {
  content: ' *';
  color: #F56C6C;
}

.form-input {
  width: 100%;
}

.form-input .el-input__inner {
  height: 48px;
  border-radius: 8px;
  border: 1px solid #E4E7ED;
  font-size: 14px;
  padding: 0 16px;
  transition: border-color 0.3s;
}

.form-input .el-input__inner:focus {
  border-color: #1E80FF;
}

.form-actions {
  text-align: center;
}

.confirm-btn {
  width: 200px;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  background: #1E80FF;
  border-color: #1E80FF;
}

.confirm-btn:hover {
  background: #0F71E3;
  border-color: #0F71E3;
}

.form-switch {
  margin-top: 8px;
}
</style>
